import { Component, Input, OnInit } from '@angular/core';
import { CompanyType } from 'src/app/settings/constants';
import { AuthService } from 'src/app/auth/services/auth.service';
import constants from 'src/app/shared/constants';

@Component({
  selector: 'app-configuration-list-component',
  templateUrl: './configuration-list-component.html',
  styleUrls: ['./configuration-list-component.scss'],
})
export class ConfigurationListComponent implements OnInit {
  @Input() company: CompanyType;

  displayedColumns: string[] = ['name', 'apiKey', 'ip', 'monitoringPort', 'receiverEventPort', 'snifferPort'];
  dataSource: any[];

  show = false;

  constructor(public authService: AuthService) {}

  ngOnInit(): void {
    this.dataSource = this.company.receivers;
  }

  isLast(item: any, array: string | any[]) {
    return array[array.length - 1] === item;
  }

  onKaironIsEnabledChange(company: any, newValue: boolean) {
    if (company.kairon?.isEnabled !== newValue) {
      company.kairon.isEnabled = newValue;
    }
  }

  canManageKaironVoice(): boolean {
    return this.authService.canManageKaironVoice(this.company._id);
  }

  isKaironEnabled(): boolean {
    return this.authService.isFeatureFlagEnabled(constants.featureFlags.iaKairon, this.company._id);
  }

  isMaiaEnabled(): boolean {
    return this.authService.isFeatureFlagEnabled(constants.featureFlags.iaMaia, this.company._id);
  }
}
